import React from 'react'
import {useForm} from '@formiz/core';
import {Button} from '@chakra-ui/react';
import {FormattedMessage} from "react-intl";

export const NextButton = (props) => {
    const form = useForm({subscribe: 'form'});
    return (
        <Button
            type="submit"
            size="md"
            width="100%"
            colorScheme="blue"
            className="secondary-btn"
            isDisabled={
                (form.isLastStep ? !form.isValid : !form.isStepValid)
                && form.isStepSubmitted
            }
            {...props}
        >
            {form.isLastStep ? <FormattedMessage id="form.button.finish"/> : <FormattedMessage id="form.button.next"/>}
        </Button>
    );
};
